export default function Banner2({
  layoutType = "layout1",
  rank,
  title,
  subtitle,
  ctaText,
  image,
  bgimage,
  items = [],
}) {
  console.log("Banner2 received items:", items);

  const renderTitleList = () => {
    if (!items.length) return title;

    return (
      <ul className="list-disc pl-4 space-y-1">
        {items.map((item, idx) => (
          <li key={idx} className="text-white text-base font-normal">
            {item.title || "No title"} — {item.price || "No price"}
          </li>
        ))}
      </ul>
    );
  };

  if (layoutType === "layout1") {
    return (
      <div
        className="bg-red-100 flex items-center justify-center text-white font-bold text-xl"
        style={{
          width: "480px",
          height: "240px",
          backgroundImage: `url(${bgimage})`,
        }}
      >
        <div className="w-full flex flex-col items-start p-4">
          <div className="inline-block bg-white px-3 py-1 rounded-full shadow">
            <span className="text-black text-xs font-bold">{rank}222</span>
          </div>
          <div className="text-white text-xl font-extrabold leading-tight mb-4">
            {title}
          </div>
          <div className="text-white text-xl font-extrabold leading-tight mb-4">
            {renderTitleList()}
          </div>
          <div className="text-white text-l mb-6">{subtitle}</div>
          <button className="bg-pink-500 text-white text-sm px-4 py-2 rounded-full font-semibold shadow hover:bg-pink-600 transition">
            {ctaText}
          </button>
        </div>
        {image && (
          <div className="w-full mt-12">
            <img src={image} alt="ad" className="w-full rounded-lg" />
          </div>
        )}
      </div>
    );
  }
  if (layoutType === "layout2") {
    return (
      <div
        className="bg-red-100 flex items-center justify-center text-white font-bold text-xl"
        style={{
          width: "240px",
          height: "480px",
          backgroundImage: `url(${bgimage})`,
        }}
      >
        <div className="w-full flex flex-col items-start p-4">
          <div className="inline-block bg-white px-3 py-1 rounded-full shadow">
            <span className="text-black text-xs font-bold">{rank}</span>
          </div>
          <div className="text-white text-xl font-extrabold leading-tight mb-4">
            {title}
          </div>
          <div className="text-white text-l mb-6">{subtitle}</div>
          <button className="bg-pink-500 text-white text-sm px-4 py-2 rounded-full font-semibold shadow hover:bg-pink-600 transition">
            {ctaText}
          </button>
        </div>
        {image && (
          <div className="w-full mt-12">
            <img src={image} alt="ad" className="w-full rounded-lg" />
          </div>
        )}
      </div>
    );
  }
  return (
    <div
      className="bg-red-100 flex items-center justify-center text-white font-bold text-xl"
      style={{
        width: "240px",
        height: "240px",
        backgroundImage: `url(${bgimage})`,
      }}
    >
      <div className="w-full flex flex-col items-start p-4">
        {rank && (
          <div className="inline-block bg-white px-3 py-1 rounded-full shadow">
            <span className="text-black text-xs font-bold">{rank}</span>
          </div>
        )}
        <div className="text-white text-xl font-extrabold leading-tight mb-4">
          {title}
        </div>
        {subtitle && <div className="text-white text-l mb-6">{subtitle}</div>}
        {ctaText && (
          <button className="bg-pink-500 text-white text-sm px-4 py-2 rounded-full font-semibold shadow hover:bg-pink-600 transition">
            {ctaText}
          </button>
        )}
      </div>
      {image && (
        <div className="w-full mt-12">
          <img src={image} alt="ad" className="w-full rounded-lg" />
        </div>
      )}
    </div>
  );
}
